import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './Loader.scss';

class Loader extends PureComponent {
  render() {
    const { children, isLoading, } = this.props;

    const loaderComponent = <div className="loading loading--double" />;
    const hasChild = Boolean(children);
    if (!hasChild) {
 return loaderComponent;
}
    return (
      <div className="loader-container">
        {isLoading && (
          <div className="overlay-container">
            {loaderComponent}
            <div className="overlay" />
          </div>
        )}
        {children}
      </div>
    );
  }
}

Loader.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
};

Loader.defaultProps = {
  children: null,
  isLoading: false,
};

export default Loader;
